import { BrandLogo } from "@/components/BrandLogo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { LogOut } from "lucide-react";
import { Link, Outlet, useNavigate } from "react-router-dom";

export function ContractorLayout() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-dvh flex flex-col">
      <header className="border-b border-line">
        <div className="mx-auto max-w-5xl px-6 py-4 flex items-center justify-between gap-4">
          <Link to="/contractor" className="text-ink no-underline">
            <BrandLogo />
          </Link>
          <div className="flex items-center gap-3">
            <span className="text-xs uppercase tracking-[0.18em] text-ink-dim">Contractor</span>
            <Button
              variant="ghost"
              size="sm"
              onClick={async () => {
                await signOut();
                navigate("/login");
              }}
            >
              <LogOut size={14} />
              Sign out
            </Button>
          </div>
        </div>
      </header>
      <main className="flex-1">
        <div className="mx-auto max-w-5xl px-4 md:px-6 py-6 md:py-10">
          <Outlet />
        </div>
      </main>
      <footer className="border-t border-line">
        <div className="mx-auto max-w-5xl px-6 py-6 text-xs text-ink-dim">
          &copy; {new Date().getFullYear()} Trinium Property Management
        </div>
      </footer>
    </div>
  );
}
